<template>
  <div>
    <mt-tabbar v-model="message" fixed>
      <mt-tab-item id="HomePage">
        <img slot="icon" :src="this.atabs[0]">
        首页
      </mt-tab-item>
      <mt-tab-item id="Cart" v-show="!this.hasPcKey">
        <img slot="icon" :src="this.atabs[1]">
        购物车
      </mt-tab-item>
      <mt-tab-item id="Mine">
        <img slot="icon" :src="this.atabs[2]">
        我的
      </mt-tab-item>
    </mt-tabbar>

  </div>

</template>

<script>
  import {getCookie} from "../util/util";

  export default {
    data () {
      return {
        message: this.selected,
        atabs: this.tabs,
        hasPcKey: getCookie("pc") ? true : false,
        providerId: this.$store.state.providerId || localStorage.getItem("providerId") || ''
      }
    },
    props:{
      selected: String,
      tabs: Array,
    },
    watch: {
      message: function (val, oldVal) {
        // 这里就可以通过 val 的值变更来确定去向
        // console.log(val)
        switch(val) {
          case 'HomePage':
            this.providerId?this.$router.push({path: "/company/index", query: {id: this.providerId}}):this.$router.push('/')
            break;
          case 'Cart':
            this.$router.push('/cart');
            break;
          case 'Mine':
            this.$router.push('/mine/myReport');
            break;
         }
      },
      '$store.state.providerId': function(val) {
        this.providerId = val
      }
    },
    methods:{

    },
  }
</script>

<style scoped>
  /deep/ .mint-tabbar{
    z-index: 9999;
  }
  .mint-tabbar > .mint-tab-item.is-selected{
    color: #00C5B0;
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Tabbar.vue